import { IProductCategory } from '@/customTypings/ProductCategory';
import { authHeader, handleResponse } from '../helpers';

export const productCategoryService = {
    add,
    get,
    edit,
    remove,
    getAll,
    getAllListItems,
};

function add(productCategory: IProductCategory) {
    const requestOptions: RequestInit = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(productCategory),
    };
    return fetch(`api/productcategory/add`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function get(id: string) {
    const requestOptions: RequestInit = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`api/productcategory/get?id=${id}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function edit(productCategory: IProductCategory) {
    const requestOptions: RequestInit = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(productCategory),
    };
    return fetch(`api/productcategory/edit`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function remove(productCategoryId: string) {
    const requestOptions: RequestInit = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`api/productcategory/delete?id=${productCategoryId}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAll() {
    const requestOptions: RequestInit = {
        method: 'GET',
        headers: authHeader(),
        credentials: "include"
    };
    return fetch(`api/productcategory/getall`, requestOptions)
        .then(handleResponse);
}

function getAllListItems() {
    const requestOptions = { method: 'POST', headers: authHeader() };
    return fetch(`api/productcategory/alllistitems`, requestOptions).then(handleResponse);
}